import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { CookieConsent } from './components/CookieConsent';
import { Home } from './pages/Home';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Monitoring } from './pages/Monitoring';
import { IncidentResponse } from './pages/IncidentResponse';
import { ThreatHunting } from './pages/ThreatHunting';
import { SiemManagement } from './pages/SiemManagement';
import { NetworkMonitoring } from './pages/monitoring/NetworkMonitoring';
import { EndpointMonitoring } from './pages/monitoring/EndpointMonitoring';
import { CloudSecurity } from './pages/monitoring/CloudSecurity';
import { ApplicationSecurity } from './pages/monitoring/ApplicationSecurity';
import { LogManagement } from './pages/monitoring/LogManagement';
import { ForensicAnalysis } from './pages/incident-response/ForensicAnalysis';
import { ActiveHunting } from './pages/threat-hunting/ActiveHunting';
import { LogAnalysis } from './pages/siem/LogAnalysis';
import { GetStarted } from './pages/GetStarted';
import { Privacy } from './pages/Privacy';

declare global {
  interface Window {
    chatwootSDK: {
      run: (config: any) => void;
    };
  }
}

function App() {
  useEffect(() => {
    // Initialize Chatwoot with custom settings
    const initChatwoot = () => {
      if (window.chatwootSDK) {
        window.chatwootSDK.run({
          websiteToken: 'amH5cfgSEMBL76iWbSERmzjP',
          baseUrl: 'https://app.chatwoot.com',
          darkMode: true,
          position: 'right',
          locale: 'en',
          type: 'expanded',
          launcherTitle: 'Need Help? Chat with us!',
          showPopoutButton: true,
          widgetStyle: {
            height: '700px',
            width: '400px',
            background: '#1F2937', // Gray-800
            color: '#F9FAFB', // Gray-50
          },
          // Make the launcher button more prominent
          launcher: {
            style: {
              backgroundColor: '#3B82F6', // Blue-500
              borderRadius: '12px',
              padding: '16px',
              boxShadow: '0 8px 16px rgba(59, 130, 246, 0.5)',
              width: '80px',
              height: '80px',
            }
          }
        });
      }
    };

    // Load Chatwoot script
    const script = document.createElement('script');
    script.src = 'https://app.chatwoot.com/packs/js/sdk.js';
    script.async = true;
    script.onload = initChatwoot;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <div className="hero-pattern">
        <div className="container mx-auto px-6 py-16 text-white">
          <Navigation />
        </div>
      </div>
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPost />} />
        <Route path="/monitoring" element={<Monitoring />} />
        <Route path="/monitoring/network" element={<NetworkMonitoring />} />
        <Route path="/monitoring/endpoint" element={<EndpointMonitoring />} />
        <Route path="/monitoring/cloud" element={<CloudSecurity />} />
        <Route path="/monitoring/application" element={<ApplicationSecurity />} />
        <Route path="/monitoring/logs" element={<LogManagement />} />
        <Route path="/incident-response" element={<IncidentResponse />} />
        <Route path="/incident-response/forensic" element={<ForensicAnalysis />} />
        <Route path="/threat-hunting" element={<ThreatHunting />} />
        <Route path="/threat-hunting/active" element={<ActiveHunting />} />
        <Route path="/siem" element={<SiemManagement />} />
        <Route path="/siem/log-analysis" element={<LogAnalysis />} />
        <Route path="/get-started" element={<GetStarted />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>

      <Footer />
      <CookieConsent />
    </div>
  );
}

export default App;